function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME MOVES

 Players communicate with each other by sending game moves. A "move" is sent with a lot
 of metadata that is parsed to make sure moves are processed in the correct order 
 (because we have no guarantees about the order in which transactions are received on/off chain
 and some games utilize SIMULTANEOUS moves). 

 A move is sent with a +1 on the game.step.game / game.step.players[player] from the sending
 player. When received,  we check if the move will be the next one or if it should be 
 saved as a future move.  Future moves is an array of unprocessed received transactions.
 Moves may also be temporarily saved as "future" if the game is halted for UI reasons,
 is "active" (i.e. running through the queue), or still initializing from a page load.
 This prevents interruption of game execution and makes sure all the players have their
 queues properly synchronized.

 **********************************************************************************/

var saito = require('./../../saito/saito');
var Transaction = require('./../../saito/transaction')["default"];
var GameMoves = /*#__PURE__*/function () {
  function GameMoves() {
    _classCallCheck(this, GameMoves);
  }
  return _createClass(GameMoves, [{
    key: "hasMyResolvePending",
    value:
    //
    // experimental function around converting counter_or_acknowledge commands to
    // ackwnoledge commands after a certain period of delay to permit faster gameplay
    // i.e. you have N seconds to respond, after which the other player can move
    // and your counter_or_acknowledge is just acknowledging.
    //
    // a late player might have a RESOLVE queued in Future Moves and process it after
    // processing an intervention like Gout in HIS that clears the counter_or_acknowledge
    // such that RESOLVE destroys the consistency of the queue.
    //
    function () {
      var _hasMyResolvePending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$game2;
        var pending, i, tx, txmsg, _this$game, _txmsg$step, _i, z, ftx, ftxmsg, _this$game3, _i2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.app.wallet.getPendingTransactions();
            case 1:
              pending = _context.v;
              i = 0;
            case 2:
              if (!(i < pending.length)) {
                _context.n = 6;
                break;
              }
              tx = pending[i];
              txmsg = tx.returnMessage();
              if (!(txmsg && txmsg.module == this.name)) {
                _context.n = 5;
                break;
              }
              if (!(txmsg.game_id === ((_this$game = this.game) === null || _this$game === void 0 ? void 0 : _this$game.id))) {
                _context.n = 5;
                break;
              }
              if (!(txmsg !== null && txmsg !== void 0 && (_txmsg$step = txmsg.step) !== null && _txmsg$step !== void 0 && _txmsg$step.game)) {
                _context.n = 5;
                break;
              }
              if (!(txmsg.step.game > this.game.step.players[tx.from[0].publicKey])) {
                _context.n = 5;
                break;
              }
              _i = 0;
            case 3:
              if (!(_i < txmsg.turn.length)) {
                _context.n = 5;
                break;
              }
              if (!(txmsg.turn[_i].indexOf('RESOLVE') >= 0)) {
                _context.n = 4;
                break;
              }
              return _context.a(2, 1);
            case 4:
              _i++;
              _context.n = 3;
              break;
            case 5:
              i++;
              _context.n = 2;
              break;
            case 6:
              if (!((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.future)) {
                _context.n = 11;
                break;
              }
              z = 0;
            case 7:
              if (!(z < this.game.future.length)) {
                _context.n = 11;
                break;
              }
              ftx = new Transaction();
              ftx.deserialize_from_web(this.app, this.game.future[z]);
              if (!(ftx.from[0].publicKey == this.game.players[this.game.player - 1])) {
                _context.n = 10;
                break;
              }
              ftxmsg = ftx.returnMessage();
              if (!(ftxmsg && ftxmsg.module == this.name)) {
                _context.n = 10;
                break;
              }
              if (!(ftxmsg.game_id === ((_this$game3 = this.game) === null || _this$game3 === void 0 ? void 0 : _this$game3.id))) {
                _context.n = 10;
                break;
              }
              _i2 = 0;
            case 8:
              if (!(_i2 < ftxmsg.turn.length)) {
                _context.n = 10;
                break;
              }
              if (!(ftxmsg.turn[_i2].indexOf('RESOLVE') >= 0)) {
                _context.n = 9;
                break;
              }
              if (!this.isUnprocessedMove(this.game.player, ftxmsg)) {
                _context.n = 9;
                break;
              }
              return _context.a(2, 1);
            case 9:
              _i2++;
              _context.n = 8;
              break;
            case 10:
              z++;
              _context.n = 7;
              break;
            case 11:
              return _context.a(2, 0);
          }
        }, _callee, this);
      }));
      function hasMyResolvePending() {
        return _hasMyResolvePending.apply(this, arguments);
      }
      return hasMyResolvePending;
    }()
    /**
     * Check what moves are pending in my wallet and if any of them are future moves
     * (I sent, but haven't received and processed) return 1
     */
  }, {
    key: "getPendingGameMoves",
    value: function () {
      var _getPendingGameMoves = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$game4;
        var arrived, z, ftx, pending, i, tx, txmsg, _this$game5, _txmsg$step2, matched, zz;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              arrived = [];
              if ((_this$game4 = this.game) !== null && _this$game4 !== void 0 && _this$game4.future) {
                for (z = 0; z < this.game.future.length; z++) {
                  ftx = new Transaction();
                  ftx.deserialize_from_web(this.app, this.game.future[z]);
                  arrived.push(ftx);
                }
              }
              _context2.n = 1;
              return this.app.wallet.getPendingTransactions();
            case 1:
              pending = _context2.v;
              for (i = 0; i < pending.length; i++) {
                tx = pending[i];
                txmsg = tx.returnMessage();
                if (txmsg && txmsg.module == this.name) {
                  if (txmsg.game_id === ((_this$game5 = this.game) === null || _this$game5 === void 0 ? void 0 : _this$game5.id)) {
                    if (txmsg !== null && txmsg !== void 0 && (_txmsg$step2 = txmsg.step) !== null && _txmsg$step2 !== void 0 && _txmsg$step2.game) {
                      if (txmsg.step.game > this.game.step.players[tx.from[0].publicKey]) {
                        //
                        // if this transaction is already in our FUTURE list then
                        // it has arrived and is not pending, and we can safely
                        // continue.
                        //
                        matched = false;
                        for (zz = 0; zz < arrived.length; zz++) {
                          if (JSON.stringify(txmsg) === JSON.stringify(arrived[zz].returnMessage())) {
                            matched = true;
                          }
                        }

                        // FEB 16, 2024
                        if (matched == true) {
                          // skip this one
                        } else {
                          if (!this.pending.includes(tx)) {
                            this.pending.push(tx);
                          }
                        }
                      }
                    }
                  }
                }
              }
              return _context2.a(2, 0);
          }
        }, _callee2, this);
      }));
      function getPendingGameMoves() {
        return _getPendingGameMoves.apply(this, arguments);
      }
      return getPendingGameMoves;
    }() //
    // Query the archives of your peers for the most recent game moves
    // Fixes out-of-sync game states
    // Code copied from game-menu.js so it can live as a more general function
    // in the game engine, also called automatically when players are refreshing
    // to try to fix the game...
  }, {
    key: "fetchRecentGameMoves",
    value: function () {
      var _fetchRecentGameMoves = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this = this;
        var newtx, recipients;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context4.v;
              recipients = [];
              this.game.accepted.forEach(function (player) {
                if (player != _this.publicKey) {
                  newtx.addTo(player);
                  recipients.push(player);
                }
              });
              newtx.msg = {
                request: 'game relay recent moves',
                module: this.name,
                game_id: this.game.id,
                timestamp: new Date().getTime()
              };
              this.app.connection.emit('relay-send-message', {
                request: 'game relay recent moves',
                recipient: recipients,
                data: newtx.toJson()
              });
              this.app.storage.loadTransactions({
                field4: this.game.id
              }, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(txs) {
                  var i;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        siteMessage("Analyzing ".concat(txs.length, " recent moves..."), 2500);
                        i = txs.length - 1;
                      case 1:
                        if (!(i >= 0)) {
                          _context3.n = 3;
                          break;
                        }
                        _context3.n = 2;
                        return _this.onConfirmation(-1, txs[i], 0);
                      case 2:
                        i--;
                        _context3.n = 1;
                        break;
                      case 3:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }(), null);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function fetchRecentGameMoves() {
        return _fetchRecentGameMoves.apply(this, arguments);
      }
      return fetchRecentGameMoves;
    }() //
    // we accept this as the next move if it is either one more than the current
    // in the MASTER step (i.e. legacy for two player games) or if it is one more
    // than the last move made by the specific player (i.e. 3P simultaneous moves)
    //
  }, {
    key: "isFutureMove",
    value: function isFutureMove(playerpkey, txmsg) {
      var tx_step = parseInt(txmsg.step.game) - 1;
      if (txmsg.game_id !== this.game.id) {
        return 0;
      }
      if (tx_step <= Math.min(this.game.step.game, this.game.step.players[playerpkey])) {
        return 0;
      }
      if (tx_step > Math.max(this.game.step.game, this.game.step.players[playerpkey])) {
        return 1;
      }
      return 0;
    }

    //
    // 1 = yes
    // 0 = unsure
    // -1 = no
    //
  }, {
    key: "isUnprocessedMoveQuickCheck",
    value: function isUnprocessedMoveQuickCheck(publickey, step, gameid) {
      if (!this.app.options) {
        return 0;
      }
      if (!this.app.options.games) {
        return 0;
      }
      var gameobj = null;
      for (var z = 0; z < this.app.options.games.length; z++) {
        if (this.app.options.games[z].id === gameid) {
          gameobj = this.app.options.games[z];
        }
      }
      if (!gameobj == null) {
        return -1;
      }
      if (!gameobj.step) {
        return 0;
      }
      if (!gameobj.step.players) {
        return 0;
      }
      if (gameobj.step.players[publickey] < step) {
        return 1;
      }
      if (gameobj.step.players[publickey] >= step) {
        return -1;
      }
      return 0;
    }

    /*
      Is this tx the next game move? It should have a step exactly one more than the main game
      or it should be more than my last move as a player
      @param player - the public key address of the player
    */
  }, {
    key: "isUnprocessedMove",
    value: function isUnprocessedMove(player, txmsg) {
      var tx_step = parseInt(txmsg.step.game) - 1;
      if (txmsg.game_id !== this.game.id) {
        return 0;
      }
      if (tx_step == this.game.step.game) {
        return 1;
      }
      if (this.game.step.players[player] !== undefined) {
        if (tx_step == this.game.step.players[player]) {
          return 1;
        }

        //
        // this is our classic check, which means that the tx_step we received is NOT larger than the game step itself
        // so our error with SIMULTANEOUS moves is likely somewhere in here, because on occasion we seem to receive
        // a resolve that is valid but fits the first criteria (advance in our move) but also is +1 ahead of the current
        // game step. i.e. tx_step ==
        //
        // it used to be this, but maybe P1's move shifts step.game so that it gets ignored
        if (tx_step > this.game.step.players[player] && tx_step < this.game.step.game) {
          return 1;
        }
        if (tx_step > this.game.step.players[player] && tx_step == this.game.step.game) {
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "fetchRecentMoves",
    value: function fetchRecentMoves() {
      /*****
                  let query = this.module + '_' + this.game.id;
                   this.app.storage.loadTransactions(
                    {
                            field1: query
                          },
                          async (txs) => {
                            for (let i = txs.length - 1; i >= 0; i--) {
                                    await this.onConfirmation(-1, txs[i], 0);
                                  }
                          },
                  );
      ****/
    }
  }, {
    key: "addNextMove",
    value: function () {
      var _addNextMove = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(gametx) {
        var gametxmsg, guard, i;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              gametxmsg = gametx.returnMessage();
              guard = this.halted == 1 || this.gaming_active == 1 || this.game.initialize_game_run == 0;
              if (!guard) {
                _context5.n = 2;
                break;
              }
              console.info("GT [addNextMove] -- save as future move because halted (".concat(this.halted, ") or active (").concat(this.gaming_active, ") or not initialized (").concat(this.game.initialize_game_run, "): ").concat(JSON.stringify(gametxmsg)));
              _context5.n = 1;
              return this.addFutureMove(gametx);
            case 1:
              return _context5.a(2);
            case 2:
              this.game.step.players[gametx.from[0].publicKey] = gametxmsg.step.game;
              if (gametxmsg.step.game > this.game.step.game) {
                this.game.step.game = gametxmsg.step.game;
                this.game.step.timestamp = gametxmsg.step.timestamp;
                this.stopClock(this.game.players.indexOf(gametx.from[0].publicKey) + 1);
              }

              // reset turn on receiving it back
              this.game.turn = [];
              if (this.gameBrowserActive()) {
                window.location.hash = this.app.browser.modifyHash(window.location.hash, {
                  step: gametxmsg.step.game
                });
              }

              //
              // ADDED JULY 31, 2024
              //
              // ASYNC games may receive Next Move while the game is not technically initialized, in
              // which case we want to make sure the game has initialized (prepared the data objects
              // and processed any outstanding game moves in the queue
              //
              // to avoid problems, only do this if not in game
              //
              if (this.browser_active) {
                _context5.n = 3;
                break;
              }
              _context5.n = 3;
              return this.initializeGameQueue(this.game.id);
            case 3:
              if (!this.game.queue) {
                _context5.n = 5;
                break;
              }
              for (i = 0; i < gametxmsg.turn.length; i++) {
                this.game.queue.push(gametxmsg.turn[i]);
              }
              console.info("GT [addNextMove] -- (".concat(gametxmsg.step.game, ", ").concat(this.app.keychain.returnUsername(gametx.from[0].publicKey), "): "), gametxmsg.turn);
              this.saveFutureMoves(this.game.id);
              this.saveGame(this.game.id);
              _context5.n = 4;
              return this.startQueue();
            case 4:
              _context5.n = 6;
              break;
            case 5:
              console.error('No queue in game engine');
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function addNextMove(_x2) {
        return _addNextMove.apply(this, arguments);
      }
      return addNextMove;
    }() //
    // cache the move, so we can share it as needed
    //
  }, {
    key: "cacheRecentMove",
    value: function cacheRecentMove(gametx) {
      try {
        while (this.game.recent_moves_cache.length < this.game.players.length) {
          this.game.recent_moves_cache.push([]);
        }

        //
        // keep 3 moves per player
        //
        var idx = 0;
        for (var z = 0; z < this.game.players.length; z++) {
          if (gametx.to[0].publicKey == this.game.players[z]) {
            idx = z;
            break;
          }
        }
        while (this.game.recent_moves_cache[idx].length > 3) {
          this.game.recent_moves_cache[idx].splice(0, 1);
        }
        var ftx = gametx.serialize_to_web(this.app);
        this.game.recent_moves_cache[idx].push(ftx);
      } catch (err) {}
    }
  }, {
    key: "addFutureMove",
    value: function () {
      var _addFutureMove = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(gametx) {
        var ftx;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!this.game.future) {
                this.game.future = [];
              }
              ftx = gametx.serialize_to_web(this.app);
              if (this.game.future.includes(ftx)) {
                _context6.n = 1;
                break;
              }
              this.game.future.push(ftx);
              this.saveFutureMoves(this.game.id);
              if (!(this.game.player == 0 && this.gameBrowserActive() && !this.gaming_active)) {
                _context6.n = 1;
                break;
              }
              console.warn('GT: [addFutureMove] game seems stuck..., moving into processing future moves');
              _context6.n = 1;
              return this.processFutureMoves();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function addFutureMove(_x3) {
        return _addFutureMove.apply(this, arguments);
      }
      return addFutureMove;
    }()
    /*
    The goal of this function is not to process all the future moves, but to search
    the archived future moves for JUST the NEXT one, so we can continue processing the game steps
    */
  }, {
    key: "processFutureMoves",
    value: function () {
      var _processFutureMoves = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this$deferred_game_e, _this$game$future;
        var future_changed, i, ftx, ftxmsg;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              // this is always called after runQueue which locks the queue for newMoves while processing
              // but there are multiple paths out of the queue, so we unlock it here
              this.gaming_active = 0;

              //
              // process any stopgame / gameover that arrived while the queue was running
              //
              if (!((_this$deferred_game_e = this.deferred_game_end) !== null && _this$deferred_game_e !== void 0 && _this$deferred_game_e.length && this.halted != 1)) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return this.processDeferredGameEndTransactions();
            case 1:
              if (!this.game.over) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, 0);
            case 2:
              if (!(this.game.futurePlus && this.game.futurePlus[this.game.step.game])) {
                _context7.n = 4;
                break;
              }
              //>>>>>>>>>>>>>>>>>>>
              console.warn('Execute meta game transaction');
              _context7.n = 3;
              return this.handlePeerTransaction(this.app, this.game.futurePlus[this.game.step.game]);
            case 3:
              delete this.game.futurePlus[this.game.step.game];
            case 4:
              if (!(this.halted == 1 || this.game.initialize_game_run == 0)) {
                _context7.n = 5;
                break;
              }
              console.info("GT [processFutureMoves] Unable to process (".concat(this.game.future.length, ") moves now because halted (").concat(this.halted, ") or gamefeeder not initialized (").concat(this.initialize_game_run, ")"));
              return _context7.a(2, -1);
            case 5:
              console.info("GT [processFutureMoves] -- Check ".concat(this.game.future.length, " moves for next one..."));

              //Search all future moves for the next one. Only the stale-move branch
              //changes the list without saving on the way out.
              future_changed = false;
              i = 0;
            case 6:
              if (!(i < this.game.future.length)) {
                _context7.n = 10;
                break;
              }
              ftx = new Transaction();
              ftx.deserialize_from_web(this.app, this.game.future[i]);
              ftxmsg = ftx.returnMessage();
              if (!this.isUnprocessedMove(ftx.from[0].publicKey, ftxmsg)) {
                _context7.n = 8;
                break;
              }
              console.info("GT [processFutureMoves] Found FTMSG (".concat(ftxmsg.step.game, "): "), JSON.parse(JSON.stringify(ftxmsg.turn)));

              //This move (future[i]) is the next one, move it to the queue
              this.game.future.splice(i, 1);
              _context7.n = 7;
              return this.addNextMove(ftx);
            case 7:
              return _context7.a(2, 1);
            case 8:
              if (this.isFutureMove(ftx.from[0].publicKey, ftxmsg)) {
                //This move (future[i]) is still for the future, so leave it alone
              } else {
                //Old move, can ignore
                this.game.future.splice(i, 1);
                i--; // reduce index as deleted
                future_changed = true;
              }
            case 9:
              i++;
              _context7.n = 6;
              break;
            case 10:
              if (future_changed) {
                this.saveFutureMoves(this.game.id);
              }
              if (((_this$game$future = this.game.future) === null || _this$game$future === void 0 ? void 0 : _this$game$future.length) > 0) {
                console.warn("GT [processFutureMoves] We have ".concat(this.game.future.length, " future moves, but NOT the next one!"));
              }
              return _context7.a(2, 0);
          }
        }, _callee7, this);
      }));
      function processFutureMoves() {
        return _processFutureMoves.apply(this, arguments);
      }
      return processFutureMoves;
    }() //
    // saves future moves without disrupting our queue state
    // so that we can continue without reloading and reload
    // without losing future moves.
    //
  }, {
    key: "saveFutureMoves",
    value: function saveFutureMoves() {
      var _this$app$options;
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (game_id === null) {
        return;
      }
      if ((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.games) {
        for (var i = 0; i < this.app.options.games.length; i++) {
          if (this.app.options.games[i].id === this.game.id) {
            this.app.options.games[i].future = this.game.future;
          }
        }
      }
      this.app.storage.saveOptions();
    }
  }, {
    key: "prependMove",
    value: function prependMove(mv) {
      if (mv) {
        this.moves.unshift(mv);
      }
    }
  }, {
    key: "addMove",
    value: function addMove(mv) {
      if (mv) {
        this.moves.push(mv);
      }
    }
  }, {
    key: "addEndMove",
    value: function addEndMove(mv) {
      if (mv) {
        this.endmoves.push(mv);
      }
    }
  }, {
    key: "removeMove",
    value: function removeMove() {
      return this.moves.pop();
    }
  }, {
    key: "addSnapshot",
    value: function addSnapshot(restore_ui) {
      if (!this.snapshot) {
        this.snapshot = [];
      }
      this.snapshot.push({
        game: JSON.parse(JSON.stringify(this.game)),
        moves: JSON.parse(JSON.stringify(this.moves)),
        restore_ui: restore_ui
      });
    }
  }, {
    key: "restoreSnapshot",
    value: function restoreSnapshot() {
      if (!this.snapshot || this.snapshot.length == 0) {
        return 0;
      }
      var snap = this.snapshot.pop();
      this.game = JSON.parse(JSON.stringify(snap.game));
      this.moves = Array.isArray(snap.moves) ? snap.moves.slice() : [];
      if (typeof snap.restore_ui === 'function') {
        snap.restore_ui();
      }
      return 1;
    }
  }, {
    key: "clearSnapshots",
    value: function clearSnapshots() {
      this.snapshot = [];
    }

    /**
     *
     * End Turn is the developer friendly wrapper for packaging player moves to send
     * over the network.
     */
  }, {
    key: "endTurn",
    value: function () {
      var _endTurn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var nextTarget,
          extra,
          i,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              nextTarget = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : 0;
              extra = {};
              if (!nextTarget) {
                nextTarget = this.returnNextPlayer();
              }
              extra.target = nextTarget;
              this.game.turn = this.moves;

              //Not sure this is necessary, but want to reset when you send your move
              //game.target should be updated when we receive our own move and continue processing
              this.game.target = 0;
              for (i = 0; i < this.endmoves.length; i++) {
                this.game.turn.push(this.endmoves[i]);
              }
              this.moves = [];
              this.endmoves = [];
              this.clearSnapshots();

              //
              // AWAIT on this causes issues -- delays UI update
              //
              this.sendGameMoveTransaction('game', extra);
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function endTurn() {
        return _endTurn.apply(this, arguments);
      }
      return endTurn;
    }()
  }, {
    key: "sendGameMoveTransaction",
    value: function () {
      var _sendGameMoveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _game_self$game;
        var type,
          extra,
          mycallback,
          turn,
          privateKey,
          hash1,
          hash2,
          hash1_sig,
          hash2_sig,
          send_onchain_only,
          i,
          game_self,
          mymsg,
          ns,
          crypto_key,
          _crypto_key,
          newtx,
          _i3,
          _args9 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              type = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : 'game';
              extra = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
              mycallback = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : null;
              //
              // TODO - avoid browser overheating
              //
              // adding a minor delay here allows JQUERY to execute
              // out-of-order, so that the board and UI can update
              // before we take back control.
              //
              turn = this.game.turn;
              this.stopClock(this.game.player); //Don't penalize the player for this minor timeout

              // Debugging
              if (this.halted) {
                console.warn('GT [sendGameMove] Attempting to send a game move from a halted state');
              }
              _context9.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              privateKey = _context9.v;
              if (!(this.game.sroll == 1)) {
                _context9.n = 4;
                break;
              }
              hash1 = this.app.crypto.hash(Math.random());
              hash2 = this.app.crypto.hash(hash1);
              _context9.n = 2;
              return this.app.crypto.signMessage(hash1, privatekey);
            case 2:
              hash1_sig = _context9.v;
              _context9.n = 3;
              return this.app.crypto.signMessage(hash2, privatekey);
            case 3:
              hash2_sig = _context9.v;
              this.game.sroll_hash = hash1;
              this.game.sroll_done = 0;
              this.game.sroll = 0; // do not trigger next message sent

              turn.slice().unshift('SECUREROLL_END');
              turn.push('SECUREROLL\t' + this.game.player + '\t' + hash2 + '\t' + hash2_sig);
            case 4:
              if (!(this.game.player == 0)) {
                _context9.n = 5;
                break;
              }
              return _context9.a(2);
            case 5:
              if (!(this.game.opponents == undefined)) {
                _context9.n = 6;
                break;
              }
              return _context9.a(2);
            case 6:
              send_onchain_only = 0;
              for (i = 0; i < turn.length; i++) {
                if (turn[i] == 'READY') {
                  send_onchain_only = 1;
                }
              }
              game_self = this;
              mymsg = {}; //
              // steps
              //
              ns = {};
              ns.game = this.game.step.game;
              if (type == 'game') {
                ns.game++;
                ns.timestamp = this.game.time.last_sent;
                mymsg.step = ns;
              }
              console.info(' #\n', '# GT [sendGameMove] step: ' + JSON.stringify(ns) + ' - ' + this.publicKey + '\n', '#\n');

              //
              // if our crypto key is out-of-date, update -- note that SAITO and CHIPS are not checked
              //
              crypto_key = this.publicKey;
              if (!((_game_self$game = game_self.game) !== null && _game_self$game !== void 0 && _game_self$game.crypto && game_self.game.crypto !== 'SAITO' && game_self.game.crypto !== 'CHIPS')) {
                _context9.n = 8;
                break;
              }
              _crypto_key = this.app.wallet.returnCryptoAddressByTicker(game_self.game.crypto);
              if (!(_crypto_key !== this.game.keys[this.game.player - 1])) {
                _context9.n = 8;
                break;
              }
              _t = turn;
              _t2 = "CRYPTOKEY\t".concat(this.publicKey, "\t").concat(_crypto_key, "\t");
              _context9.n = 7;
              return this.app.crypto.signMessage(_crypto_key, privateKey);
            case 7:
              _t.push.call(_t, _t2.concat.call(_t2, _context9.v));
            case 8:
              mymsg.request = type;
              mymsg.turn = turn;
              mymsg.module = this.name;
              mymsg.game_id = this.game.id;
              mymsg.player = this.game.player;
              mymsg.extra = extra;
              _context9.n = 9;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 9:
              newtx = _context9.v;
              if (!(newtx == null)) {
                _context9.n = 10;
                break;
              }
              salert('ERROR: Difficulty Sending Transaction, please reload');
              return _context9.a(2);
            case 10:
              for (_i3 = 0; _i3 < this.game.accepted.length; _i3++) {
                newtx.addTo(this.game.accepted[_i3]);
              }
              newtx.msg = mymsg;
              _context9.n = 11;
              return newtx.sign();
            case 11:
              //
              // we traditionally add the transaction to pending before saving the wallet, so that
              // if there is an issue with the network we don't lose the transaction when the network
              // comes back online. refreshing the browser will also try to auto-resend the tx this way.
              //
              game_self.app.wallet.addTransactionToPending(newtx);
              game_self.saveGame(game_self.game.id);

              // console.debug('GT: Sending Move: ', JSON.parse(JSON.stringify(mymsg)));

              //
              // send off-chain if possible - step 2 onchain to avoid relay issues with options
              //
              if (this.relay_moves_offchain_if_possible && send_onchain_only == 0) {
                //
                // only game moves to start
                //
                if (newtx.msg.request === 'game' && this.game.initializing == 0 || this.initialize_game_offchain_if_possible == 1) {
                  console.log('GT [sendGameMove] emit game relay gamemove', new Date().toISOString(), Date.now());
                  this.app.connection.emit('relay-send-message', {
                    recipient: this.game.accepted,
                    request: 'game relay gamemove',
                    data: newtx.toJson()
                  });

                  //An experiment to have game steps/ts update in arcade
                  console.log('GT [sendGameMove] emit arcade spv update', new Date().toISOString(), Date.now());
                  this.app.connection.emit('relay-send-message', {
                    recipient: 'PEERS',
                    request: 'arcade spv update',
                    data: newtx.toJson()
                  });
                }
              }
              game_self.app.network.propagateTransaction(newtx);
            case 12:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function sendGameMoveTransaction() {
        return _sendGameMoveTransaction.apply(this, arguments);
      }
      return sendGameMoveTransaction;
    }()
  }]);
}();
module.exports = GameMoves;